export const PRODUCT = (import.meta.env.VITE_PRODUCT as string) || 'full'
export const IS_BOOSTER_ONLY = PRODUCT === 'booster'
// profiler — чистая сборка для наших рабочих серверов: только профайлер,
// без booster-разделов и без админки (лицензии/деплой/модерация).
export const IS_PROFILER_ONLY = PRODUCT === 'profiler'
export const HAS_PROFILER = !IS_BOOSTER_ONLY
